export enum AppVariants {
  plurall = "plurall",
  goStudentLearning = "goStudentLearning",
  seneca = "seneca"
}

export type AppVariant = keyof typeof AppVariants;
